import pages from './dataImport/spreadsheet.html';
export const hasBackButton = (pageIndex) => pages[pageIndex].choices.find(el => el.dest === 'back') != undefined;
export const isInterruptionPage = (pageIndex) => pages[pageIndex].choices.find(el => el.dest === 'back' && el.text === 'Got it!') != undefined;
export const isNormalPage = (pageIndex) => !hasBackButton(pageIndex);